export var Provider;
(function (Provider) {
    Provider["Aws"] = "AWS";
    Provider["Azure"] = "AZURE";
    Provider["Gcp"] = "GCP";
    Provider["MongoAtlas"] = "MONGO_ATLAS";
    Provider["GoogleWorkspace"] = "GOOGLE_WORKSPACE";
    Provider["Microsoft365"] = "MICROSOFT_365";
    Provider["ProviderUnspecified"] = "PROVIDER_UNSPECIFIED";
})(Provider || (Provider = {}));
